<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>

        <template slot="next_update" slot-scope="{ item }">
            {{ item.next_update | datetime }}
        </template>

        <template slot="file_name" slot-scope="{ item }">
            <a :href="'/download/risk-analysis/'+item.id" target="_blank"> {{ item.file_name }}</a>
        </template>

        <template slot="actions" slot-scope="{ item }" v-if="!isClient">
            <b-button  size="sm" variant="danger" @click="removeRiskAnalysis(item)"><i class="fa fa-trash"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>

export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: [
                    {
                        key: 'created_at',
                        label: 'Fecha creación',
                        filter: true
                    },
                    {
                        key: 'next_update',
                        label: 'Proxima actualización',
                        filter: true
                    },
                    {
                        key: 'venue.name',
                        label: 'Sede',
                        filter: true
                    },
                    {
                        key: 'reported_by.name',
                        label: 'Creador',
                        filter: true
                    },
                    {
                        key: 'file_name',
                        label: 'Archivo',
                        filter: true
                    },
                    {
                        key: 'ext',
                        label: 'Extensión',
                        filter: true
                    },
                    {
                        key: 'notes',
                        label: 'Notas',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ],
                isClient: false
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data.map(item => ({...item}));
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        removeRiskAnalysis(data){
            this.$emit('remove-risk-analysis', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    },
    created(){
        this.isClient = this.user.profile.slug === 'cliente-admin' ? true: false;
    }
}
</script>